import { useMyRobotPrimaryInformation } from 'lib/api/myRobot';

export function useMyRobotConnection() {
  const { data } = useMyRobotPrimaryInformation((d) => d.connectionState?.state);

  return { connectionState: data };
}

export function useRobotId() {
  const { data } = useMyRobotPrimaryInformation((d) => d.myRobotId);

  return { robotId: data };
}
